const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTwitterPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 128",
    style: {
      fill: "none",
      opacity: 0.502
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.945 6.3A8.185 8.185 0 0 0 20 4.174a8.563 8.563 0 0 1-2.362.648 4.078 4.078 0 0 0 1.8-2.266 8.2 8.2 0 0 1-2.6.993 4.1 4.1 0 0 0-7.093 2.8 4.222 4.222 0 0 0 .1.935A11.608 11.608 0 0 1 1.393 3a4.1 4.1 0 0 0 1.26 5.48A4.053 4.053 0 0 1 .8 7.972v.045a4.119 4.119 0 0 0 3.285 4.029 4.077 4.077 0 0 1-1.075.135 3.619 3.619 0 0 1-.776-.07 4.141 4.141 0 0 0 3.831 2.857 8.242 8.242 0 0 1-5.084 1.748A7.755 7.755 0 0 1 0 16.66a11.547 11.547 0 0 0 6.29 1.84A11.59 11.59 0 0 0 17.945 6.3z",
    transform: "translate(2 1.625)",
    style: {
      fill: "#0222ba"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitterPrimary);
export default __webpack_public_path__ + "static/media/icon-twitter-primary.1cd90e6b0c62ad0e97d879da1dd107f9.svg";
export { ForwardRef as ReactComponent };